import { shopPrefix } from '../../../../config';
import { http } from '../../../../api/axios';
import { BundleCategoryResponse } from '../bundleCategories';
import { AgeCategory } from '../../../../../models/AgeCategory';

export interface CategoryParamTypes {
    loanFormat: string;
    ageCategory: AgeCategory;
}

export function fetchBundleCategories({ loanFormat, ageCategory }: CategoryParamTypes) {
    const pathParams = {
        loanFormat: loanFormat !== 'all' ? loanFormat : null
    };

    const params = {
        ageCategory: ageCategory !== AgeCategory.ALL_AGES ? ageCategory : null
    };

    return http
        .get<BundleCategoryResponse>(`${shopPrefix}/v1/foreignlanguage/bundles/:loanFormat?/categories`, {
            params,
            pathParams
        })
        .then(response => response.data);
}
